// Sentinel identity for the built-in "My Stuff" view, distinct from any real
// SavedView returned by the API. Kept as a single source of truth so it's easy
// to extend with more built-in views later.
export const MY_STUFF_VIEW_ID = '__my_stuff__';
export const MY_STUFF_VIEW_NAME = 'My Stuff';
